export enum ESearchFilterItemRangePickerType {
    Generic = "generic",
    Duration = "duration",
}
